import LeadBox from './LeadBox';

export default LeadBox;
